/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungserstellAntragDto } from '../../models/buchungserstell-antrag-dto';

export interface CancelOneGleittagErstellAntrag$Plain$Params {

/**
 * ID des Antrags, der storniert oder zurueckgezogen werden soll
 */
  antragsId: string;
}

export function cancelOneGleittagErstellAntrag$Plain(http: HttpClient, rootUrl: string, params: CancelOneGleittagErstellAntrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungserstellAntragDto>> {
  const rb = new RequestBuilder(rootUrl, cancelOneGleittagErstellAntrag$Plain.PATH, 'post');
  if (params) {
    rb.path('antragsId', params.antragsId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungserstellAntragDto>;
    })
  );
}

cancelOneGleittagErstellAntrag$Plain.PATH = '/v1/buchungserstellAntraege/{antragsId}/cancel';
